import React from 'react';
import { escapeRegexChars } from '../../../helpers/escapeRegexChars';
import { ReactComponent as CheckMark } from '../../../assets/icons/svg/shared/ic-shared-checkmark.svg';

export type LiliComboboxWithInputValueConstraint = string | number;
export interface MenuItem<T extends LiliComboboxWithInputValueConstraint> {
  title: string;
  value: T;
  itemDescription?: string;
}

interface SelectMenuItemProps<T extends LiliComboboxWithInputValueConstraint> {
  id: string;
  item: MenuItem<T>;
  isSelected: boolean;
  searchWord?: string;
  onClick: (value: T) => void;
}
export const SelectMenuItem = <T extends LiliComboboxWithInputValueConstraint>({
  id,
  item,
  isSelected,
  searchWord,
  onClick,
}: SelectMenuItemProps<T>) => {
  const getValue = (value: string) => {
    if (!searchWord) return value;
    const regex = new RegExp(`(.*)(${escapeRegexChars(searchWord).toLowerCase()})(.*)`, 'i'); // Capturing prefix, match, and suffix
    const match = regex.exec(value);
    return match ? (
      <>
        {match[1]}
        <span className='text-action03'>{match[2]}</span>
        {match[3]}
      </>
    ) : (
      value
    );
  };
  return (
    <button
      id={`${id}-select-menu-item-${item.value}`}
      className={`${isSelected ? 'bg-action00' : 'hover:bg-bw02'} w-full px-[12px] py-[8px] flex items-center rounded-[6px] justify-between h-[42px]`}
      onClick={(event) => {
        event.stopPropagation();
        onClick(item.value);
      }}
      type='button'
    >
      <span className='flex items-center justify-between gap-[8px]'>
        <span className='text-[38px]'>{item.title}</span>
        <span>{getValue(item.itemDescription || item.title)}</span>
      </span>
      {isSelected && <CheckMark className='text-action03' />}
    </button>
  );
};
